export enum StreamlinedSerologyReason {
    PreOpTesting = 0,
    ScheduledDonation = 1
}
